import { render, staticRenderFns } from "./PanelExpansion.vue?vue&type=template&id=521f4d4e&scoped=true"
import script from "./PanelExpansion.vue?vue&type=script&lang=js"
export * from "./PanelExpansion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f4d4e",
  null
  
)

export default component.exports